import React from 'react';
import { Form, Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

export const MemberFilesTab: React.FC = () => {
    return (
        <div className="form-section">
            <Form.Item name="resume_file" label="简历">
                <Upload maxCount={1}>
                    <Button icon={<UploadOutlined />}>上传简历</Button>
                </Upload>
            </Form.Item>
        </div>
    );
};
